import moment from "moment";
import MomentUtils from "@date-io/moment";
import React, { useState } from "react";

import {localization} from '../../Frames/localization'
import i18next from 'i18next'

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
    KeyboardDatePicker,
  } from '@material-ui/pickers';
  import "moment/locale/uk";
  import "moment/locale/ru";
  import "moment/locale/en-au";
  import "moment/locale/pl";
  import "moment/locale/fr";
  import "moment/locale/de";
  import "moment/locale/es";
  import "moment/locale/zh-cn";
  import { AppliedSettings } from "../../App";

function DatePickerMinMax(props) {
  const [locale] = useState(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second));
  moment.locale(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second));
  const handleDateChange = data => {
    props.handleChangeData(data, props.id);
  };

    var s = props.min_age*365+(props.min_age/4);
    var e = props.max_age*365+(props.max_age/4);
    var _start = new Date();
    var _end = new Date();
    _start.setDate(_start.getDate() - e);
    _end.setDate(_end.getDate() - s)
  return (
    <div> 
        <MuiPickersUtilsProvider  libInstance={moment} utils={MomentUtils} locale={locale}>
        <KeyboardDatePicker    
            error={props.error == true ?true:false}      
            className={props.className}
            variant="outlined"
            inputVariant="outlined"
            format="DD/MM/YYYY"
            margin="normal"
            id={props.id}
            name={props.name}
            label={props.label}
            
            value={Number(props.value) == 0?null:Number(props.value)}
            onChange={handleDateChange}
            disabled={props.disabled}
            cancelLabel={localization.GetTranslate('Alert.cancel')}
            okLabel={localization.GetTranslate('Alert.confirm')}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            invalidDateMessage={localization.GetTranslate('Profile.Invalid Date Format')}
            maxDateMessage={localization.GetTranslate('Profile.Date should not be after maximal date')}
            minDateMessage={localization.GetTranslate('Profile.Date should not be before minimal date')}
            minDate={_start}
            maxDate={_end}
            />
           
        </MuiPickersUtilsProvider>
    </div>
  );
}


function DatePicker(props) {
  const [locale] = useState(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second));
  moment.locale(localization.chooseLangPickers(AppliedSettings.calendar_language_first, AppliedSettings.calendar_language_second));
  const handleDateChange = data => {
    props.handleChangeData(data, props.id);
  };

  return (
    <div> 
        <MuiPickersUtilsProvider  libInstance={moment} utils={MomentUtils} locale={locale}>
       
        <KeyboardDatePicker     
            error={props.error == true ?true:false}      
            className={props.className}
            variant="outlined"
            inputVariant="outlined"
            format="DD/MM/YYYY"
            margin="normal"
            id={props.id}
            name={props.name}
            label={props.label}
            
            value={Number(props.value) == 0?null:Number(props.value)}
            onChange={handleDateChange}
            disabled={props.disabled}
            cancelLabel={localization.GetTranslate('Alert.cancel')}
            okLabel={localization.GetTranslate('Alert.confirm')}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            invalidDateMessage={localization.GetTranslate('Profile.Invalid Date Format')}
            maxDateMessage={localization.GetTranslate('Profile.Date should not be after maximal date')}
            minDateMessage={localization.GetTranslate('Profile.Date should not be before minimal date')}
            />
           
        </MuiPickersUtilsProvider>
    </div>
  );
}

export { DatePicker,DatePickerMinMax};